import { Component, OnInit } from '@angular/core';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { RsbService } from 'src/app/service/rsb.service';

@Component({
  selector: 'app-my-leads',
  templateUrl: './my-leads.component.html',
  styleUrls: ['./my-leads.component.css']
})
export class MyLeadsComponent implements OnInit {
  getMylead: any[] = [
    {
      listingId: 'PB-1003',
      propertyTitle: 'Villa at Lakeview Residency',
      customerName: 'Rahul Mehta',
      cmobile: '9898765432',
      cemail: 'rahul.mehta@example.com'
    },
    {
      listingId: 'PB-1004',
      propertyTitle: '2 BHK Apartment at Green Valley',
      customerName: 'Priya Singh',
      cmobile: '9822334455',
      cemail: 'priya.singh@example.com'
    },
    {
      listingId: 'PB-1005',
      propertyTitle: 'Office Floor at Metro Plaza',
      customerName: 'Suresh Iyer',
      cmobile: '9800112233',
      cemail: 'suresh.iyer@example.com'
    },
    {
      listingId: 'PB-1006',
      propertyTitle: '4 BHK Residence at Palm Enclave',
      customerName: 'Ritu Arora',
      cmobile: '9877001122',
      cemail: 'ritu.arora@example.com'
    },
    {
      listingId: 'PB-1007',
      propertyTitle: 'Retail Unit at City Walk',
      customerName: 'Manish Gupta',
      cmobile: '9811223344',
      cemail: 'manish.gupta@example.com'
    },
    {
      listingId: 'PB-1008',
      propertyTitle: '3 BHK Apartment at Sunrise Towers',
      customerName: 'Anjali Rao',
      cmobile: '9899112233',
      cemail: 'anjali.rao@example.com'
    },
    {
      listingId: 'PB-1009',
      propertyTitle: 'Independent House at Silver Park',
      customerName: 'Vikram Shah',
      cmobile: '9833445566',
      cemail: 'vikram.shah@example.com'
    },
    {
      listingId: 'PB-1010',
      propertyTitle: 'Studio Apartment at Urban Nest',
      customerName: 'Pooja Nair',
      cmobile: '9866554433',
      cemail: 'pooja.nair@example.com'
    },
    {
      listingId: 'PB-1011',
      propertyTitle: 'Plot at Orchard County',
      customerName: 'Deepak Joshi',
      cmobile: '9844778899',
      cemail: 'deepak.joshi@example.com'
    },
    {
      listingId: 'PB-1012',
      propertyTitle: 'Penthouse at Skyline Homes',
      customerName: 'Meera Kapoor',
      cmobile: '9822110099',
      cemail: 'meera.kapoor@example.com'
    }
  ];
    constructor(
    private rsbService:RsbService,
    private rsbLookup:RsbLookupModel
  ) { 
    console.log("mylead")
  }

  ngOnInit(): void {
  }

  getMyleads() {
    this.rsbService.myLeads().subscribe((rsp) => {
      this.getMylead = rsp.contents;


    })

  }

}
